var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInSpecIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1372_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6666C4.31816 14.6666 1.3335 11.6819 1.3335 7.99992C1.3335 4.31792 4.31816 1.33325 8.00016 1.33325C11.6822 1.33325 14.6668 4.31792 14.6668 7.99992C14.6668 11.6819 11.6822 14.6666 8.00016 14.6666ZM6.98192 10.313C7.17719 10.5083 7.49379 10.5083 7.68905 10.313L11.6953 6.30614C11.8906 6.11087 11.8906 5.79431 11.6953 5.59906L11.4597 5.3635C11.2645 5.16823 10.9479 5.16824 10.7526 5.36353L7.3355 8.78125L5.80305 7.24881C5.60779 7.05354 5.2912 7.05354 5.09594 7.24881L4.86038 7.48436C4.66512 7.67963 4.66512 7.99621 4.86038 8.19147L6.98192 10.313Z",
    fill: "#1EC04A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1372_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInSpecIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/InSpecIcon.53d52b96.svg";
export { ForwardRef as ReactComponent };